<template lang="pug">
  h2 hi
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'SettingsIntercomCallback',
  components: {
  },
  beforeCreate () {

  },
  mounted () {
    console.log("mounte!!!d")
    this.$axios.get(`/integration/intercom/callback?code=${this.$route.query.code}`)
    .then(result => {
      console.log(result)
      if(result.data.url){
        window.location.href = result.data.url
      }
    })
    .catch(function(e){
      console.log('FAILURE!!')
      console.log(e)
    })

  },
  data () {
    return {
      form: {
      }
    }
  },
  computed: {
  },
  methods: {
    submit () {
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>